<template>
  <component
    :is="href ? TheNuxtLink : 'div'"
    :href
    :data-href="href"
    class="relative grid grid-cols-[auto_1fr_auto] gap-4 items-center bg-white dark:bg-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors rounded-md px-2 py-4"
  >
    <div class="flex gap-2 items-center self-start">
      <slot name="unreadIndicator" :is-unread>
        <div
          class="pointer-events-none rounded-full bg-nami-comi-blue h-2 w-2"
          :class="{
            'opacity-0': !isUnread,
          }"
        ></div>
      </slot>

      <slot name="icon">
        <NotificationsIcon
          v-if="actionIcon && !$slots.avatar"
          :icon="actionIcon"
        />
        <NotificationsAvatar v-else :action-icon>
          <template #avatar>
            <slot name="avatar">
              <AsyncImage
                src="/apple-touch-icon.png"
                class="w-12 aspect-square object-cover rounded-full self-start"
              />
            </slot>
          </template>
        </NotificationsAvatar>
      </slot>
    </div>

    <div class="mr-2">
      <slot name="content"></slot>
    </div>

    <div>
      <slot name="date">
        <NotificationsTimeAgo v-if="date" :date="date" />
      </slot>
    </div>
  </component>
</template>

<script setup lang="ts">
import { IconPlaceholder } from "@tabler/icons-vue";
import TheNuxtLink from "../the/TheNuxtLink.vue";

export interface Props {
  isUnread: boolean;
  hideCloseButton?: boolean;
  actionIcon?: typeof IconPlaceholder;
  date?: Date;
  href?: string;
}

defineProps<Props>();
</script>
